import { AfterViewInit, ApplicationRef, ChangeDetectionStrategy, Component, ComponentFactoryResolver, ElementRef, Injector, OnInit, Renderer2, ViewChild, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute,  } from '@angular/router';
import { UserService } from 'app/core/user/user.service';
import { User } from 'app/core/user/user.types';
import { UserMenuComponent } from './user-menu.component';

@Component({
	selector: 'app-header-rapallo',
	standalone: true,
	imports: [MatIconModule],
	templateUrl: './header.component.html',
	styleUrls: [
        '../../../../../../assets/styles/bootstrap-italia-comuni.min.css',
        '../../../../../../assets/styles/rapallo-style.css'
    ],
	encapsulation: ViewEncapsulation.ShadowDom,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RapalloHeaderComponent implements OnInit, AfterViewInit {
    @ViewChild('myHeader') myHeader: ElementRef;


	htmlContent:SafeHtml='';
    user:User;
    userMenu:HTMLElement

	constructor(
      private activatedRoute: ActivatedRoute,
      private userService: UserService,
      private renderer: Renderer2,
      private sanitizer: DomSanitizer,
      private view: ViewContainerRef,
      private appRef: ApplicationRef,
      private injector: Injector,
      private componentFactoryResolver: ComponentFactoryResolver

	) {}


	ngOnInit() {

      this.userService.user$.subscribe(user=>{

            //creo il componente
            const componentRef = this.view.createComponent(UserMenuComponent);

            // Passa il parametro di input
            componentRef.instance.fullName = user.fullname;

            //becco l'elemento root del componente
            this.userMenu = (componentRef.hostView as any).rootNodes[0] as HTMLElement;


    })

      this.activatedRoute.data.subscribe(({isweb}) => {

        if (isweb && isweb.length>0){
            const parser = new DOMParser();
            const content = isweb[0].content
                .replace(/https:\/\/www\.comune\.rapallo\.ge\.it\/bootstrap-italia-163\/svg\/sprites\.svg/g, '/assets/icons/sprites.svg')
                .replace('index.php?pagsistema=ricerca','https://www.comune.rapallo.ge.it/index.php?pagsistema=ricerca')
            const html = parser.parseFromString(content, 'text/html');
            this.htmlContent =  this.sanitizer.bypassSecurityTrustHtml(html.documentElement.textContent)

        }

      })

	}


    ngAfterViewInit(): void {
        //riferimento all'elemento del DOM
        //Sostituisco il pezzetto dell'utente
        const userMenu = this.myHeader.nativeElement.querySelector('.it-header-slim-right-zone');
        if (userMenu){
            //lo svuoto
            userMenu.innerHTML='';
            //appendo l'elemento root dove voglio
            this.renderer.appendChild(userMenu, this.userMenu);
        }

    }

}
